import * as React from "react"

import { cn } from "@/lib/utils"

const TEXTAREA_DEFAULT_CLASS =
  "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"

/** The touch surfaces' underline field (docs/MOBILE.md), as a textarea. */
const TEXTAREA_UNDERLINE_CLASS =
  "flex w-full resize-none rounded-none border-0 border-b border-input bg-transparent px-0 py-2 text-base font-normal text-foreground placeholder:text-muted-foreground focus-visible:border-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** `default` is the boxed desktop field; `underline` the boxless touch one. */
  variant?: "default" | "underline"
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant = "default", ...props }, ref) => {
    return (
      <textarea
        className={cn(
          variant === "underline" ? TEXTAREA_UNDERLINE_CLASS : TEXTAREA_DEFAULT_CLASS,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
